import { Injectable } from '@angular/core';
import { NewApiPlanoPagamentoService } from '../new-api-plano-pagamento/new-api-api-plano-pagamento.service';

@Injectable({
  providedIn: 'root',
})
export class AmountValueService {
  AMOUNT_VALUE = this.getAmountValue();

  constructor(
    readonly newApiPlanoPagamentoService: NewApiPlanoPagamentoService
  ) {}

  setCobranca(iD_COBRANCA: string, id_filial: string, iD_PARCELA?: number, idvend?: number, idClient?: number) {
    this.newApiPlanoPagamentoService
      .getByIdCobranca(iD_COBRANCA, id_filial, idvend, idClient)
      .subscribe((cobranca) => {
        this.AMOUNT_VALUE = 0;
        if (iD_PARCELA) this.setTax(iD_PARCELA);
      });
  }

  getAmountValue() {
    const AMOUNT_VALUE = sessionStorage.getItem('AMOUNT_VALUE');

    if (AMOUNT_VALUE && +AMOUNT_VALUE <= 0) {
      return 0;
    }
    return AMOUNT_VALUE ? +AMOUNT_VALUE : 0;
  }

  setTax(iD_PARCELA: number) {
    const tipoDeCobranca =
      this.newApiPlanoPagamentoService.tipoDeCobrancaOptions?.find(
        (option) => +option.iD_PARCELA == iD_PARCELA
      );

    if (!tipoDeCobranca) {
      sessionStorage.setItem('AMOUNT_VALUE', '0');
      return;
    }

    const AMOUNT_VALUE = tipoDeCobranca.taxA_FINANCEIRA / 100;

    this.AMOUNT_VALUE = +this.AMOUNT_VALUE + +AMOUNT_VALUE;

    sessionStorage.setItem('AMOUNT_VALUE', this.AMOUNT_VALUE.toString());
  }

  resetDiscount() {
    sessionStorage.setItem('AMOUNT_VALUE', '0');
    this.AMOUNT_VALUE = 0;
  }
}
